import { defineComponent as f, onMounted as v, h as a } from "vue";
import { getQuarterString as S, getMonthString as b, getYearString as k } from "./ghl-ui.es964.js";
import { MONTH_ITEM_HEIGHT as O } from "./ghl-ui.es1319.js";
import { useCalendarProps as C, useCalendar as _ } from "./ghl-ui.es1342.js";
import g from "./ghl-ui.es919.js";
import u from "./ghl-ui.es994.js";
import $ from "./ghl-ui.es215.js";
import d, { XButton as j } from "./ghl-ui.es253.js";
import M from "./ghl-ui.es1147.js";
const L = f({
  name: "MonthPanel",
  props: Object.assign(Object.assign({}, C), {
    type: {
      type: String,
      required: !0
    },
    // panelHeader prop
    useAsQuickJump: Boolean
  }),
  setup(t) {
    const r = _(t, t.type), {
      dateLocaleRef: o
    } = g("DatePicker"), n = (e) => {
      switch (e.type) {
        case "year":
          return k(e.dateObject.year, e.yearFormat, o.value.locale);
        case "month":
          return b(e.dateObject.month, e.monthFormat, o.value.locale);
        case "quarter":
          return S(e.dateObject.quarter, e.quarterFormat, o.value.locale);
      }
    }, {
      useAsQuickJump: c
    } = t, i = (e, s, l) => {
      const {
        mergedIsDateDisabled: h,
        handleDateClick: p,
        handleQuickMonthClick: m
      } = r;
      return a("div", {
        "data-n-date": !0,
        key: s,
        class: [`${l}-date-panel-month-calendar__picker-col-item`, e.isCurrent && `${l}-date-panel-month-calendar__picker-col-item--current`, e.selected && `${l}-date-panel-month-calendar__picker-col-item--selected`, !c && h(e.ts, e.type === "year" ? {
          type: "year",
          year: e.dateObject.year
        } : e.type === "month" ? {
          type: "month",
          year: e.dateObject.year,
          month: e.dateObject.month
        } : e.type === "quarter" ? {
          type: "month",
          year: e.dateObject.year,
          month: e.dateObject.quarter
        } : null) && `${l}-date-panel-month-calendar__picker-col-item--disabled`],
        onClick: () => {
          c ? m(e, (y) => {
            t.onUpdateValue(y, !1);
          }) : p(e);
        }
      }, n(e));
    };
    return v(() => {
      r.justifyColumnsScrollState();
    }), Object.assign(Object.assign({}, r), {
      renderItem: i
    });
  },
  render() {
    const {
      mergedClsPrefix: t,
      mergedTheme: r,
      shortcuts: o,
      actions: n,
      renderItem: c,
      type: i,
      onRender: e
    } = this;
    return e == null || e(), a("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${t}-date-panel`, `${t}-date-panel--month`, !this.panel && `${t}-date-panel--shadow`, this.themeClass],
      onFocus: this.handlePanelFocus,
      onKeydown: this.handlePanelKeyDown
    }, a("div", {
      class: `${t}-date-panel-month-calendar`
    }, a(u, {
      ref: "yearScrollbarRef",
      class: `${t}-date-panel-month-calendar__picker-col`,
      theme: r.peers.Scrollbar,
      themeOverrides: r.peerOverrides.Scrollbar,
      container: this.virtualListContainer,
      content: this.virtualListContent,
      horizontalRailStyle: {
        zIndex: 1
      },
      verticalRailStyle: {
        zIndex: 1
      }
    }, {
      default: () => a($, {
        ref: "yearVlRef",
        items: this.yearArray,
        itemSize: O,
        showScrollbar: !1,
        keyField: "ts",
        onScroll: this.handleVirtualListScroll,
        paddingBottom: 4
      }, {
        default: ({
          item: s,
          index: l
        }) => c(s, l, t)
      })
    }), i === "month" || i === "quarter" ? a("div", {
      class: `${t}-date-panel-month-calendar__picker-col`
    }, a(u, {
      ref: "monthScrollbarRef",
      theme: r.peers.Scrollbar,
      themeOverrides: r.peerOverrides.Scrollbar
    }, {
      default: () => [(i === "month" ? this.monthArray : this.quarterArray).map((s, l) => c(s, l, t)), a("div", {
        class: `${t}-date-panel-${i}-calendar__padding`
      })]
    })) : null), this.datePickerSlots.footer ? a("div", {
      class: `${t}-date-panel-footer`
    }, {
      default: this.datePickerSlots.footer
    }) : null, n != null && n.length || o ? a("div", {
      class: `${t}-date-panel-actions`
    }, a("div", {
      class: `${t}-date-panel-actions__prefix`
    }, o && Object.keys(o).map((s) => {
      const l = o[s];
      return Array.isArray(l) ? null : a(j, {
        size: "tiny",
        onMouseenter: () => {
          this.handleSingleShortcutMouseenter(l);
        },
        onClick: () => {
          this.handleSingleShortcutClick(l);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => s
      });
    })), a("div", {
      class: `${t}-date-panel-actions__suffix`
    }, n != null && n.includes("clear") ? a(d, {
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, n != null && n.includes("now") ? a(d, {
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleNowClick
    }, {
      default: () => this.locale.now
    }) : null, n != null && n.includes("confirm") ? a(d, {
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isDateInvalid,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, a(M, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  L as default
};
